import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import CategoryPage from "../pages/category/page";
import TagPage from "../pages/tag/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/category/:slug",
    element: <CategoryPage />,
  },
  {
    path: "/tag/:slug",
    element: <TagPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;